import Image from 'next/image';
import img from '@/public/img/rooms/HHExcslusive05.jpg';
import img2 from '@/public/img/rooms/4.jpg';
import img3 from '@/public/img/rooms/15.jpg';
import { useTranslation } from 'next-i18next';
import Button from '../button/Button';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { DotButton } from '../embla/EmblaDots';
import Autoplay from 'embla-carousel-autoplay';

const SpecialOffersHero = () => {
  const { t } = useTranslation('specialOffers');
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true }, [Autoplay({ delay: 3000 })]);
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const scrollTo = useCallback((index: number) => emblaApi && emblaApi.scrollTo(index), [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
  }, [emblaApi, setScrollSnaps, onSelect]);
  return (
    <section className='mb-20 relative h-[546px] flex items-center'>
      <div className='embla absolute top-0 left-0 w-full h-full z-[-1]'>
        <div className='embla__viewport h-full' ref={emblaRef}>
          <div className='embla__container h-full'>
            <div className='embla__slide'>
              <div className='overlay'></div>
              <Image src={img} alt='' fill style={{ objectFit: 'cover', zIndex: -1 }} priority={true} placeholder='blur' />
            </div>
            <div className='embla__slide'>
              <div className='overlay'></div>
              <Image src={img2} alt='' fill style={{ objectFit: 'cover', zIndex: -1 }} priority={true} placeholder='blur' />
            </div>
            <div className='embla__slide'>
              <div className='overlay'></div>
              <Image src={img3} alt='' fill style={{ objectFit: 'cover', zIndex: -1 }} priority={true} placeholder='blur' />
            </div>
          </div>
        </div>
      </div>
      <div className='embla__dots z-1 bottom-12 right-12'>
        {scrollSnaps.map((_, index) => (
          <DotButton key={index} selected={index === selectedIndex} onClick={() => scrollTo(index)} />
        ))}
      </div>
      <div className='container mx-auto px-4 z-2'>
        <h1 className='text-white text-5xl font-bold mb-8'>{t('hero.title')}</h1>
        <p className='text-white mb-10 max-w-3xl'>{t('hero.description')}</p>
        <Button text={t('hero.btn')} link='#rezervace' style='yellow'></Button>
      </div>
    </section>
  );
};

export default SpecialOffersHero;
